import { i18n } from '@/utils/i18n';

export const columns = {
    id: {
        show: true,
        title: "№",
        sortable: true,
        column: 'id'
    },

    partner_clinic_id: {
        show: true,
        title: i18n.t('message.partner_clinic'),
        sortable: true,
        column: 'partner_clinic'
    },

    count: {
        show: true,
        title: i18n.t('message.count'),
        sortable: true,
        column: 'count'
    },

    total_amount: {
        show: true,
        title: i18n.t('message.total_amount'),
        sortable: true,
        column: 'total_amount'
    },

    is_paid: {
        show: true,
        title: i18n.t('message.status'),
        sortable: true,
        column: 'is_paid'
    },

    created_at: {
        show: true,
        title: i18n.t('message.date'),
        sortable: true,
        column: 'created_at'
    },
    updated_at: {
        show: false,
        title: i18n.t('message.update_date'),
        sortable: true,
        column: 'updated_at'
    },
    settings: {
        show: true,
        title: i18n.t('message.settings'),
        sortable: false,
        column: 'settings'
    }
};
